import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
    Avatar,
    Box,
    Button,
    Card,
    Grid,
    IconButton,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { deleteObjectApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { STATUS_REVIEW } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from "sweetalert2";
import DecisionStatusListDataTableCard from '../DataTable/decisionStatus/DecisionStatusListDataTableCard';
import config from 'config';
import { getUserFullName } from 'app/utils/appHelpers';

function AddUpdateDecisionStatusCard({ selectedDecision, afterUpdateFunc }) {
    const { authUser } = useSelector((state) => state.auth);
    const [localDecision, setLocalDecision] = useState(selectedDecision);
    const [isEditing, setIsEditing] = useState(false);
    const [editingStatusId, setEditingStatusId] = useState(null);
    const userList = useSelector((state) => state.user.data || []);
    // Not: Backend artık statusReview toplu alanlarını güvenli ayırıcı (|||) ile döndürüyor.
    // Bu yüzden info metninde virgül olsa bile split(',') yapıp metni kesmiyoruz.
    const STATUS_SEPARATOR = '|||';

    // id/pdate/userId alanları virgül içermez; bu yüzden geriye dönük uyumluluk için
    // ayırıcı yoksa virgüle düşebiliriz.
    const splitMulti = (value) => {
        const str = (value || '').toString();
        if (!str) return [];
        return str.includes(STATUS_SEPARATOR) ? str.split(STATUS_SEPARATOR) : str.split(',');
    };

    // info alanı virgül içerebildiği için ayırıcı yoksa tüm metni tek parça kabul ediyoruz.
    const splitInfos = (value) => {
        const str = (value || '').toString();
        if (!str) return [];
        return str.includes(STATUS_SEPARATOR) ? str.split(STATUS_SEPARATOR) : [str];
    };

    useEffect(() => {
        setLocalDecision(selectedDecision);
    }, [selectedDecision]);

    const getEmptyDstatusObj = () => ({
        userId: authUser.id,
        info: '',
        decisionId: selectedDecision?.id,
        meetingId: selectedDecision?.meetingId,
        pdate: new Date()
    });
    const [dstatusObj, setDstatusObj] = useState(getEmptyDstatusObj());

    const handleChange = (value, parameter) => {
        setDstatusObj({ ...dstatusObj, [parameter]: value });
    };

    const handleAddDstatusInfo = async () => {
        const apiResponse = await postSaveObjectApi(STATUS_REVIEW, dstatusObj);
        if (apiResponse.status) {
            const newReviewId = apiResponse.data.insertId;
            const currentDateStr = new Date().toISOString();
            const newUserStatusId = localDecision && localDecision.userStatusId
                ? `${newReviewId}${STATUS_SEPARATOR}${localDecision.userStatusId}`
                : `${newReviewId}`;
            const newUserStatusInfo = localDecision && localDecision.userStatusInfo
                ? `${dstatusObj.info}${STATUS_SEPARATOR}${localDecision.userStatusInfo}`
                : dstatusObj.info;
            const newUserStatusPdate = localDecision && localDecision.userStatusPdate
                ? `${currentDateStr}${STATUS_SEPARATOR}${localDecision.userStatusPdate}`
                : currentDateStr;
            const newStatusReviewUserIds = localDecision && localDecision.statusReviewUserIds
                ? `${authUser.id}${STATUS_SEPARATOR}${localDecision.statusReviewUserIds}`
                : `${authUser.id}`;

            const updatedFields = {
                userStatusId: newUserStatusId,
                userStatusInfo: newUserStatusInfo,
                userStatusPdate: newUserStatusPdate,
                statusReviewUserIds: newStatusReviewUserIds
            };

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Ekleme başarılı.',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                    container: 'swal-container-custom'
                },
            });
            const swalModal = document.querySelector('.swal2-container');
            if (swalModal) {
                swalModal.style.zIndex = '9999';
            }
            setLocalDecision(prev => ({ ...prev, ...updatedFields }));
            setDstatusObj(prev => ({ ...prev, info: '' }));

            if (afterUpdateFunc) {
                afterUpdateFunc(updatedFields, localDecision.id);
            }
        }
    };

    const handleDeleteStatus = async (statusId) => {
        const result = await Swal.fire({
            title: 'Emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'İptal',
            customClass: {
                container: 'swal-container-custom'
            },
        });

        if (result.isConfirmed) {
            const apiResponse = await deleteObjectApi(STATUS_REVIEW, statusId);
            if (apiResponse.status) {
                const idsStr = localDecision.userStatusId || '';
                const infosStr = localDecision.userStatusInfo || '';
                const pdatesStr = localDecision.userStatusPdate || '';
                const usersStr = localDecision.statusReviewUserIds || '';

                const idsArr = splitMulti(idsStr);
                const infosArr = splitInfos(infosStr);
                const pdatesArr = splitMulti(pdatesStr);
                const usersArr = splitMulti(usersStr);

                const zipped = idsArr
                    .filter(id => id && id !== '')
                    .map((id, i) => ({
                        id: (id || '').toString(),
                        info: typeof infosArr[i] !== 'undefined' ? infosArr[i] : '',
                        pdate: typeof pdatesArr[i] !== 'undefined' ? pdatesArr[i] : '',
                        userId: typeof usersArr[i] !== 'undefined' ? usersArr[i] : ''
                    }));

                const filtered = zipped.filter(item => item.id !== statusId.toString());

                const updatedFields = {
                    userStatusId: filtered.map(x => x.id).join(STATUS_SEPARATOR),
                    userStatusInfo: filtered.map(x => x.info).join(STATUS_SEPARATOR),
                    userStatusPdate: filtered.map(x => x.pdate).join(STATUS_SEPARATOR),
                    statusReviewUserIds: filtered.map(x => x.userId).join(STATUS_SEPARATOR)
                };

                setLocalDecision(prev => ({ ...prev, ...updatedFields }));
                if (afterUpdateFunc) {
                    afterUpdateFunc(updatedFields, localDecision.id);
                }

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Silme işlemi başarılı.',
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                });
            }
        }
    };

    const handleEditStatus = (statusId, currentInfo) => {
        setIsEditing(true);
        setEditingStatusId(statusId);
        setDstatusObj(prev => ({ ...prev, info: currentInfo }));
    };

    const handleUpdateStatus = async () => {
        if (!editingStatusId) return;

        const apiResponse = await putUpdateObjectApi(STATUS_REVIEW, {
            id: editingStatusId,
            info: dstatusObj.info
        });

        if (apiResponse.status) {
            const idsStr = localDecision.userStatusId || '';
            const infosStr = localDecision.userStatusInfo || '';
            const statusIds = splitMulti(idsStr);
            const statusInfos = splitInfos(infosStr);
            const index = statusIds.indexOf(editingStatusId.toString());

            if (index > -1) {
                statusInfos[index] = dstatusObj.info;
                const updatedFields = {
                    userStatusInfo: statusInfos.join(STATUS_SEPARATOR)
                };

                setLocalDecision(prev => ({ ...prev, ...updatedFields }));
                if (afterUpdateFunc) {
                    afterUpdateFunc(updatedFields, localDecision.id);
                }

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Güncelleme başarılı.',
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        container: 'swal-container-custom'
                    },
                });

                // Reset editing state
                setIsEditing(false);
                setEditingStatusId(null);
                setDstatusObj(prev => ({ ...prev, info: '' }));
            }
        }
    };

    const handleCancelEdit = () => {
        // İptal: hiçbir işlem yapma, API'ye gitme. Sadece inputu temizle ve edit modundan çık.
        setIsEditing(false);
        setEditingStatusId(null);
        setDstatusObj(prev => ({ ...prev, info: '' }));
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card>
                        <Box sx={{ padding: 2 }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs>
                                    <TextField
                                        required
                                        variant="outlined"
                                        placeholder="Açıklama"
                                        multiline
                                        fullWidth
                                        value={dstatusObj.info}
                                        type="text"
                                        rows={2}
                                        onChange={(e) => handleChange(e.target.value, "info")}
                                        InputLabelProps={{ shrink: true }}
                                        label="Açıklama"
                                    />
                                </Grid>
                                <Grid item>
                                    {isEditing ? (
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleUpdateStatus}
                                                sx={{ mr: 1 }}
                                            >
                                                Güncelle
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={handleCancelEdit}
                                            >
                                                İptal
                                            </Button>
                                        </>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleAddDstatusInfo}
                                        >
                                            Ekle
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <Box sx={{ padding: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                Uygulanma Detayları
                            </Typography>
                            {localDecision && localDecision.userStatusId && (() => {
                                const idsStr = localDecision.userStatusId || '';
                                const infosStr = localDecision.userStatusInfo || '';
                                const pdatesStr = localDecision.userStatusPdate || '';
                                const usersStr = localDecision.statusReviewUserIds || '';

                                const idsArr = splitMulti(idsStr);
                                const infosArr = splitInfos(infosStr);
                                const pdatesArr = splitMulti(pdatesStr);
                                const usersArr = splitMulti(usersStr);

                                const records = idsArr
                                    .map((id, i) => ({
                                        id: (id || '').trim(),
                                        info: typeof infosArr[i] !== 'undefined' ? infosArr[i].trim() : '',
                                        pdate: typeof pdatesArr[i] !== 'undefined' ? pdatesArr[i].trim() : '',
                                        userId: typeof usersArr[i] !== 'undefined' ? usersArr[i].trim() : ''
                                    }))
                                    .filter(r => r.id !== '')
                                    .sort((a, b) => new Date(b.pdate) - new Date(a.pdate));
                                return (
                                    <Box>
                                        {records.map((rec) => {
                                            const user = userList.find(user => user.id === Number(rec.userId));
                                            return (
                                                <Box key={rec.id} sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    mb: 2,
                                                    p: 1,
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: 1
                                                }}>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Avatar
                                                                sx={{ height: 25, width: 25 }}
                                                                alt={user?.name || ""}
                                                                src={
                                                                    user?.profileImageUrl
                                                                        ? `${config.userAuthApiUrl}${user.profileImageUrl}`
                                                                        : undefined
                                                                }
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl;
                                                                }}
                                                            /> {getUserFullName(user) + " : "}
                                                            <Typography variant="body1">{rec.info}</Typography>
                                                        </Box>
                                                        <Typography variant="caption" color="textSecondary">
                                                            {new Date(rec.pdate).toLocaleString('tr-TR')}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Tooltip title={rec.userId === authUser.id.toString() ? "Düzenle" : "Sadece kendi kayıtlarınızı düzenleyebilirsiniz"}>
                                                            <span>
                                                                <IconButton
                                                                    onClick={() => handleEditStatus(rec.id, rec.info)}
                                                                    color="primary"
                                                                    size="small"
                                                                    disabled={rec.userId !== authUser.id.toString()}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip title={rec.userId === authUser.id.toString() ? "Sil" : "Sadece kendi kayıtlarınızı silebilirsiniz"}>
                                                            <span>
                                                                <IconButton
                                                                    onClick={() => handleDeleteStatus(rec.id)}
                                                                    color="error"
                                                                    size="small"
                                                                    disabled={rec.userId !== authUser.id.toString()}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                );
                            })()}
                        </Box>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <Box sx={{ padding: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                Seçili Karar Detayları
                            </Typography>
                            {localDecision ? (
                                <DecisionStatusListDataTableCard
                                    mainData={[localDecision]}
                                    afterUpdateFunc={afterUpdateFunc}
                                />
                            ) : (
                                <Typography variant="body2">Karar bilgisi bulunamadı.</Typography>
                            )}
                        </Box>
                    </Card>
                </Grid>
            </Grid>
            <br />
        </>
    );
}


const style = document.createElement('style');
style.innerHTML = `
    .swal-container-custom {
        z-index: 10000 !important;
    }
`;
document.head.appendChild(style);


export default AddUpdateDecisionStatusCard;